export const getRegularPriceForPriceRange = (
  cartItemPrice: number,
  quantityPrice: number,
  weightablePrice: number,
  isWeightable: boolean,
): number | null => {
  if (isWeightable) {
    const actualWeightPrice = Number(weightablePrice.toFixed(2));
    return cartItemPrice !== actualWeightPrice ? actualWeightPrice : null;
  }
  const actualQtyPrice = Number(quantityPrice.toFixed(2));
  return cartItemPrice !== actualQtyPrice ? actualQtyPrice : null;
};
